import * as tslib_1 from "tslib";
import { map, takeUntil } from 'rxjs/operators';
import { OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as checkout from '../../actions/checkout';
import * as fromCheckout from '../../reducers';
import * as fromAuth from '../../../auth/reducers';
import * as fromBase from '../../../base/reducers';
import { ContainerBase } from '../../../core/base/container-base';
import { PageRoutingService } from '../../../core/services/page-routing.service';
var SummaryContainer = /** @class */ (function (_super) {
    tslib_1.__extends(SummaryContainer, _super);
    function SummaryContainer(store, pageRoutingSvc, route) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.pageRoutingSvc = pageRoutingSvc;
        _this.route = route;
        _this.pageRoutingSvc.breadcrumbsStatus = false;
        route.params.pipe(map(function (params) { return new checkout.OrderSummary(params.id); }))
            .subscribe(store);
        _this.order$ = _this.store.pipe(select(fromCheckout.getSummaryOrder), takeUntil(_this.destroyed$));
        _this.addresses$ = _this.store.pipe(select(fromAuth.getAddresses), takeUntil(_this.destroyed$));
        _this.quantityPicker$ = _this.store
            .pipe(select(fromBase.getQuantityPicker), takeUntil(_this.destroyed$));
        _this.checkoutPageSettings$ = store
            .pipe(select(fromBase.getCheckoutPageSettings), takeUntil(_this.destroyed$));
        _this.extraCosts$ = store
            .pipe(select(fromCheckout.getSummaryOrderExtraCosts), takeUntil(_this.destroyed$));
        return _this;
    }
    SummaryContainer.prototype.ngOnDestroy = function () {
        this.pageRoutingSvc.breadcrumbsStatus = true;
    };
    return SummaryContainer;
}(ContainerBase));
export { SummaryContainer };
